import { getPlatformIcons } from "../../lib/platform-icons";

export function PlatformIcon({ platform }: { platform: "YT" | "Twitch" }) {
  const platformIcons = getPlatformIcons("default");
  return (
    <span
      aria-hidden="true"
      className="inline-block size-3.5 shrink-0 bg-current"
      style={{ maskImage: `url("${platformIcons[platform]}")`, maskSize: "contain", maskRepeat: "no-repeat" }}
    />
  );
}
